import { useState } from 'react';
import type { Timeout } from 'react-number-format/types/types';

interface setTimer {
  step: number;
  timeout: null | number;
  isTimeoutFinished?: boolean;
}

interface UseTimerProps {
  defaultStep?: number;
}

let timeoutID: Timeout;
export const useTimer = (props: UseTimerProps) => {
  const { defaultStep = 1000 } = props;
  const [timer, setTimer] = useState<setTimer>({
    step: defaultStep,
    timeout: null,
    isTimeoutFinished: undefined,
  });

  const tick = (timeout: number) => {
    setTimer({
      ...timer,
      timeout,
      isTimeoutFinished: Number(timeout) <= 0,
    });
    const { isTimeoutFinished, step } = timer;

    if (isTimeoutFinished) {
      clearTimeout(timeoutID);
    }

    if (!isTimeoutFinished) {
      timeoutID = setTimeout(() => {
        tick(timeout - step);
      }, timer.step);
    }
  };

  const startTimeout = (timeout: number, step = defaultStep) => {
    setTimer({
      ...timer,
      timeout,
      step,
      isTimeoutFinished: false,
    });
    tick(timeout);
  };

  const finishTimeout = () => {
    clearTimeout(timeoutID);
    setTimer({
      ...timer,
      timeout: null,
      isTimeoutFinished: true,
    });
  };

  return {
    startTimeout,
    finishTimeout,
    isTimeoutFinished: timer.isTimeoutFinished,
    timeout: timer.timeout,
  };
};
